import BoolQuestionViewModel from 'jobs/questions/Bool/BoolQuestionViewModel'
import DocumentsQuestionViewModel from 'jobs/questions/Documents/DocumentsQuestionViewModel'
import { QuestionViewModelPort } from 'jobs/questions/QuestionViewModelBase'
import TextQuestionViewModel from 'jobs/questions/Text/TextQuestionViewModel'
import UnknownQuestionViewModel from 'jobs/questions/Unknown/UnknownQuestionViewModel'
import { Id } from 'types/definitions'
import { assertNotNil } from 'utils/error-util'
import { AnswerPromptPayload, DeletePromptPayload } from './payloads'
import { PromptsModulePorts } from './ports'
import { Prompt } from './Prompt'
import PromptStore from './PromptStore'

export function PromptsModuleAdapter(
  promptStore: PromptStore,
  questionViewModelAdapter: QuestionViewModelPort,
): PromptsModulePorts {
  return {
    createQuestionViewModel(prompt: Prompt) {
      const question = assertNotNil(
        prompt.question,
        'prompt question was undefined',
      )

      switch (question.type) {
        case 'TEXT':
          return new TextQuestionViewModel(questionViewModelAdapter)
            .configure(
              {
                multiLine: true,
                showErrorMessages: true,
              },
              { minLength: 1, maxLength: 280 },
            )
            .hydrateDTO(question)

        case 'BOOL':
          return new BoolQuestionViewModel(questionViewModelAdapter)
            .configure({ showErrorMessages: true })
            .hydrateDTO(question)

        case 'DOCUMENTS':
          return new DocumentsQuestionViewModel(questionViewModelAdapter)
            .configure(
              { showErrorMessages: true, readOnly: Boolean(question.answer) },
              { minDocsRequired: 1 },
            )
            .hydrateDTO(question)

        default:
          return new UnknownQuestionViewModel(questionViewModelAdapter) as any
      }
    },

    fetchPromptsForJob(query) {
      return promptStore.fetchPromptsForJob(query)
    },

    promptsForJob(id) {
      return promptStore.promptsForJob(Id.assert(id))
    },

    answerPrompt(answerPayload: AnswerPromptPayload) {
      return promptStore.answerPrompt(answerPayload)
    },

    deletePrompt(deletePayload: DeletePromptPayload) {
      return promptStore.deletePrompt(deletePayload)
    },
  }
}
